export default "/images/friends-at-gate.jpg?2f7d5d66c8afce4c29986c6eaa46ee3c";